
import * as D from '../data-utils';

  import $ from 'jquery';
  import App from '../app';
  import PathNode from './PathNode.js';
  import FloorChangeNode from './FloorChangeNode.js';
  import PathLink from './PathLink.js';
  import FloorRoute from './FloorRoute.js';
  import Constants from './Constants';

  import {calculateMeanInitialRouteDirection} from './Direction';

  var mapdata = {};
  var context;

  function init(scimddata, imddata, appContext){
    context = appContext;
    var lang = D.lang();
    var translations = App.getTranslations(lang);
    var floorNodes = [];
    var links = [];
    floorNodes = getRouteNodes(scimddata);
    links = getRoutePaths(scimddata);
    createFloorChangeNodes(lang);

    mapdata.floorNodes = floorNodes;
    mapdata.links = links;
    mapdata.imddata = imddata;
    mapdata.serviceLocations = getServiceLocations();
    mapdata.startPoint = {};
    mapdata.startNode = {};
    mapdata.endNode = {};

    return mapdata;
  }


  function getFloors(){
    var lang = D.lang();
    var scdata = App.getStoredData('scdata', lang);
    return scdata.shoppingCenterData.floors;
  }
  function getServiceLocations(){
    return D.servicelocations();
  }

  /*ROUTE NODES*/
  function getRouteNodes(scimddata){
    var floordata = scimddata.imdFloors;
    var nodes = [];
    $.each(floordata, function(i, floor){
      var floorIndex = getFloorIndex(floor.floorId);
      nodes[floorIndex] = [];
      $.each(floor.routeNodes, function(j, routeNode){
        var node = new PathNode(routeNode.name, routeNode.coordinates.x, routeNode.coordinates.y, floorIndex);
        nodes[floorIndex].push(node);
      });
    });
    mapdata.floorNodes = nodes;
    return nodes;
  }

  /*ROUTE PATHS */
  function getRoutePaths(scimddata){
    var floors = scimddata.imdFloors;
    var links;

    $.each(floors, function(i, floor){
      var floorIndex = getFloorIndex(floor.floorId);
      var routePaths = floor.routePaths;
      $.each(routePaths, function(j, routePath){
        var startnode = getNodeByName(floors, floorIndex, routePath.node1);
        var endnode = getNodeByName(floors, floorIndex, routePath.node2);
        if(startnode && endnode){
          createInterpolatedConnection(floorIndex, startnode, endnode);
        }
      });
    });
  }

  /*GET NODE BY NAME*/
  function getNodeByName(floors, floorIndex, nodename){
    var floorNodes = mapdata.floorNodes[floorIndex];
    for(var i=0; i<floorNodes.length; i++){
      if(floorNodes[i].name==nodename){
        return floorNodes[i];
      }
    }

    return false;
  }

  /* CREATE INTERPOLATED CONNECTIONS */
  function createInterpolatedConnection(floorIndex, startnode, endnode){
    var x = startnode.x;
    var y = startnode.y;

    var distanceX = endnode.x - startnode.x;
    var distanceY = endnode.y - startnode.y;
    var distance = calculateDistance(endnode, startnode);
    //Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));

    var numDots = Math.floor(distance / Constants.INTERPOLATION_STEP);

    var dx = distanceX / numDots;
    var dy = distanceY / numDots;

    var previous = startnode;
    var current = startnode;

    mapdata.links = mapdata.links || [];

    for(var i = 0; i < numDots; i++) {
      x = x + dx;
      y = y + dy;

      current = new PathNode('n'+i, x, y, floorIndex);

      mapdata.floorNodes[floorIndex].push(current);

      mapdata.links.push(current.connectTo(previous));
      mapdata.links.push(previous.connectTo(current));
      previous = current;
    }
    mapdata.links.push(current.connectTo(endnode));
    mapdata.links.push(endnode.connectTo(current));
  }

  /* CREATE LINK */
  function createLink(node1, node2, cost = -1){
    try {
      var link = node1.connectTo(node2, cost);
      if(link!=null){
        mapdata.links.push(link);
      }
    } catch (Exception) {
      return null;
    }
  }

  /* CREATE FLOOR CHANGE NODES*/
  function createFloorChangeNodes(){

    var serviceLocations = getServiceLocations();
    var floorChangeNodeGroups=[];

    for(var s=0; s<serviceLocations.length; s++){
      if(typeof serviceLocations[s].floorChangerGroupId != 'undefined'){
        var serviceLocationGroupid = serviceLocations[s].floorChangerGroupId;
        var floorIndex = serviceLocations[s].floorIndex;

        var exists = 0;
        for(var i in floorChangeNodeGroups){
          if(floorChangeNodeGroups[i].id==serviceLocationGroupid){
            exists=1;
          }
        }
        if(exists==0){
          var nodeGroup = { id: serviceLocationGroupid, nodes: [] };
          floorChangeNodeGroups.push(nodeGroup);
        }

        var newNode = new FloorChangeNode('', serviceLocations[s]);

        for(var i in floorChangeNodeGroups){
          if(floorChangeNodeGroups[i].id == serviceLocationGroupid){
            floorChangeNodeGroups[i].nodes.push(newNode);
          }
        }
        mapdata.floorNodes[floorIndex].push(newNode);
      }
    }

    for(var i in floorChangeNodeGroups){
      var floorChangerNodes = floorChangeNodeGroups[i].nodes;

      for(var j in floorChangerNodes){
        var serviceType = floorChangerNodes[j].serviceType;
        var servicePenalty;
        var cost;
        if(serviceType == 9)
        {
          servicePenalty = Constants.ESCALATOR_SERVICE_PENALTY;
          cost = Constants.ESCALATOR_COST;
        }
        else
        {
          servicePenalty = Constants.ELEVATOR_SERVICE_PENALTY;
          cost = Constants.ELEVATOR_COST;
        }

        var point = {x: floorChangerNodes[j].x, y: floorChangerNodes[j].y};
        var floorIndex = floorChangerNodes[j].floorIndex;
        var distance = Constants.MAX_VALUE;
        var nearestNode = findNearestNode(floorIndex, point, distance);
        if(nearestNode!=null){
          var newDistance = calculateDistance(floorChangerNodes[j], nearestNode);
          createLink(floorChangerNodes[j], nearestNode, newDistance);
          createLink(nearestNode, floorChangerNodes[j], newDistance);
        }else{
        }
      }
      for(var n = 0; n < floorChangerNodes.length - 1; n++) {
        var node1 = floorChangerNodes[n];
        for (var j = n; j < floorChangerNodes.length; j++) {
          var node2 = floorChangerNodes[j];
          var floorDifference = Math.abs(node1.floorIndex - node2.floorIndex);
          createLink(node1, node2, floorDifference * cost + servicePenalty);
          createLink(node2, node1, floorDifference * cost + servicePenalty);
        }
      }
    }
  }
  function calculateDistance(node1, node2){
    var distanceX = node1.x - node2.x;
    var distanceY = node1.y - node2.y;

    var distance = Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
    return distance;
  }
  /* GET IMD DATA*/
  function getImdData(){
    var x;
    var y;
    var floorIndex;
    var scimddata = D.scimddata();
    var scimd = scimddata.shoppingCenterImdData;
    for(var i in scimd.imds){
      if(scimd.imds[i].id==context.imdId){
        x = scimd.imds[i].coordinates.x;
        y = scimd.imds[i].coordinates.y;
        floorIndex = getFloorIndex(scimd.imds[i].floorId);
      }
    }

    var imdData = {floorIndex: floorIndex, x: x, y: y};

    return imdData;
  }

  /*DO FIND SHORTEST PATH TREE*/
  function doFindShortestPathTree(floorIndex, startPoint){
    var distance = Constants.MAX_VALUE;
    var startNode;
    var closestnode = findNearestNode(floorIndex, startPoint, distance);
    if (closestnode != null) {
      // Save the new path root.
      mapdata.startNode = closestnode;
      // Find the shortest path.
      findShortestPathTree();
    }
  }

  /*FIND NEAREST NODE*/
  function findNearestNode(floorIndex, point, distance){

    var tempDistance;
    var closestNode = null;

    if(mapdata.floorNodes == undefined) {
      //Temp scimddata needs to be created here to get mapdata, since mapdata hasn't been initialized if this function is called outside of map view.
      mapdata.floorNodes = getRouteNodes(D.scimddata());
    }

    var nodes = mapdata.floorNodes[floorIndex];
    for(var i = 0; i<nodes.length; i++){
      tempDistance = calculateDistance(point, nodes[i]);
      if (tempDistance < distance && nodes[i].type == 'pathNode') {
        distance = tempDistance;
        closestNode = nodes[i];
      }
    }

    return closestNode;
  }


  // Find the shortest path tree starting at m_StartNode.
  function findShortestPathTree(){

    // Reset all nodes' BestDist'
    for(var f in mapdata.floorNodes){
      for(var i=0; i<mapdata.floorNodes[f].length; i++){
        mapdata.floorNodes[f][i].BestDist = Constants.MAX_VALUE;
        mapdata.floorNodes[f][i].BestLink = null;
        mapdata.floorNodes[f][i].IsInCl = false;
      }
    }

    // Remove all links from the path tree.
    for(var link in mapdata.links) {
      mapdata.links[link].IsInPathTree = false;
    }

    // Add the root node to the candidate list.
    var cl = [];
    cl.push(mapdata.startNode);
    mapdata.startNode.BestDist = 0;
    mapdata.startNode.IsInCl = true;

    // Process the candidate list until empty.
    while (cl.length > 0) {

      // Search the list for the node that's closest to the root.
      var bestIndex = 0;
      var bestDistance = Constants.MAX_VALUE;

      for(var i = 0; i < cl.length; i++) {
        if(cl[i]){
          var pathNode = cl[i];
          if(pathNode.BestDist < bestDistance) {
            bestIndex = i;
            bestDistance = pathNode.BestDist;
          }
        }
      }

      //Remove the best node from the candidate list.
      var testNode = cl[bestIndex];
      cl.splice(bestIndex,1);
      testNode.IsInCl = false;

      // Add this node's neighbors to the candidate list.
      for(var neighborLink in testNode.links) {
        // See if this neighbor's best distance can be improved.
        try{
          var neighborNode = testNode.links[neighborLink].toNode;
          var newDistance = testNode.BestDist + testNode.links[neighborLink].Cost;

          if (newDistance < neighborNode.BestDist) {
            // This is an improvement. Update the neighbor.
            neighborNode.BestDist = newDistance;
            neighborNode.BestLink = testNode.links[neighborLink];

            // If the neighbor is not in the candidate list, add it.
            if (!neighborNode.IsInCl) {
              neighborNode.IsInCl = true;
              cl.push(neighborNode);
            }
          }
        }catch(err){}
      }
    }

    // Mark all of the nodes in the shortest path tree.
    for(var f in mapdata.floorNodes){
      if(mapdata.floorNodes[f].BestLink!=null){
        mapdata.floorNodes[f].BestLink.IsInPathTree = true;
      }
    }
  }

  /* FIND CLOSEST STORE LOCATION*/
  function findClosestStoreLocationForStore(store){
    var closestStoreLocation = null;
    var bestDistance = Constants.MAX_VALUE;

    for(var storeLocation in store.storeLocations) {
      var floorIndex = store.storeLocations[storeLocation].floorIndex;
      var doorLocation = store.storeLocations[storeLocation].doorLocation;
      var closestNode = findNearestNode(floorIndex, doorLocation, Constants.MAX_VALUE);
      if(closestNode!=null && closestNode.BestDist <= bestDistance) {
        bestDistance = closestNode.BestDist;
        closestStoreLocation = store.storeLocations[storeLocation];
      }
    }

    return closestStoreLocation;
  }

  function findClosestStoreLocationForStoreAtFloor(store, floorIndex){
    var closestStoreLocation = null;
    var bestDistance = Constants.MAX_VALUE;

    for(var storeLocation in store.storeLocations) {
      if(floorIndex == store.storeLocations[storeLocation].floorIndex){
        var doorLocation = store.storeLocations[storeLocation].doorLocation;
        var closestNode = findNearestNode(floorIndex, doorLocation, Constants.MAX_VALUE);
        if(closestNode!=null && closestNode.BestDist <= bestDistance) {
          bestDistance = closestNode.BestDist;
          closestStoreLocation = store.storeLocations[storeLocation];
        }
      }
    }
    return closestStoreLocation;
  }
  /* FIND CLOSEST SERVICE LOCATION*/
  function findClosestServiceLocation(service){
    var closestServiceLocation = null;
    var bestDistance = Constants.MAX_VALUE;
    for(var s in mapdata.serviceLocations) {
      if(mapdata.serviceLocations[s].serviceType==service.id){
        var point = mapdata.serviceLocations[s].pinLocation;
        var floorIndex = mapdata.serviceLocations[s].floorIndex;

        var closestNode = findNearestNode(floorIndex, point, Constants.MAX_VALUE);
        if(closestNode!=null && closestNode.BestDist < bestDistance) {
          bestDistance = closestNode.BestDist;
          closestServiceLocation = mapdata.serviceLocations[s];
        }
      }

    }
    return closestServiceLocation;
  }

  /* DO FIND SHORTEST PATH */
  function doFindShortestPath(floorIndex, startPoint, endPoint, minDirectionDistance, maxDirectionDistance){
    // If we have no path tree yet, do nothing.
    if(mapdata.startNode == null) {
      return null;
    }
    mapdata.startPoint = startPoint;
    var distance = Constants.MAX_VALUE;
    var closestNode = null;
    mapdata.endPoint = endPoint;
    closestNode = findNearestNode(floorIndex, mapdata.endPoint, distance);
    if (closestNode != null) {
      mapdata.endNode = closestNode;
      return findShortestPath(minDirectionDistance, maxDirectionDistance);
    } else {
      return null;
    }
  }

  /* FIND SHORTEST PATH */
  function findShortestPath(minDirectionDistance, maxDirectionDistance){
    // Find the shortest path from m_StartNode to m_EndNode.
    // Start at the destination node and work backward.
    var testNode = mapdata.endNode;
    var floorIndex = testNode.floorIndex;
    var floorName = getFloorName(floorIndex);
    var fullRoute = [];

    var currentFloorRoute = new FloorRoute(floorIndex);
    currentFloorRoute.FloorName = floorName;
    var polyline = { Points: [] };

    if (mapdata.endNode.type == 'FloorChangeNode') {
      testNode = mapData.endNode.BestLink.fromNode;
      var serviceType = mapData.endNode.serviceType;
      for(var s in Constants.SERVICE_TYPES){
        if(Constants.SERVICE_TYPES[s].id == serviceType){
          currentFloorRoute.EndIcon = Constants.SERVICE_TYPES[s].pinicon;
          currentFloorRoute.EndPoint = {x: testNode.x, y: testNode.y};
        }
      }
    }

    var dx = mapdata.endPoint.x - mapdata.endNode.x;
    var dy = mapdata.endPoint.y - mapdata.endNode.y;
    var ds2 = Math.pow(dx, 2.0) + Math.pow(dy, 2.0);
    if (ds2 > 0) {
      polyline.Points.push({x: mapdata.endPoint.x, y: mapdata.endPoint.y});
      var distance = Math.sqrt(ds2);

      //draw dots between endnode and endpoint
      if(distance > 10){
        var count = distance/10;
        var amountX = dx/count;
        var amountY = dy/count;

        for(var i=1; i<count; i++){
          var newPoint = {};
          if(mapdata.endNode.x < mapdata.endPoint.x){
            newPoint.x = mapdata.endPoint.x - Math.abs(amountX*i);
          }else{
            newPoint.x = mapdata.endPoint.x + Math.abs(amountX*i);
          }
          if(mapdata.endNode.y < mapdata.endPoint.y){
            newPoint.y = mapdata.endPoint.y - Math.abs(amountY*i);
          }else{
            newPoint.y = mapdata.endPoint.y + Math.abs(amountY*i);
          }

          polyline.Points.push(newPoint);
        }

      }

      polyline.Points.push({x: mapdata.endNode.x, y: mapdata.endNode.y});
    }

    let nextIsFloorChange = false;

    // Icons of the last route (finish to destination route)
    currentFloorRoute.StartIcon = 'pin_you-are-here';
    currentFloorRoute.GuidingIcon = 'ic_map-pin';
    // This is the location where the dots end
    currentFloorRoute.EndPoint = {x: mapdata.endPoint.x, y: mapdata.endPoint.y};

    let lastNodeOfRoute;

    if (testNode.BestLink != null) {
      lastNodeOfRoute = testNode;
      while(testNode != mapdata.startNode) {
        if(testNode.type == 'FloorChangeNode') {
          var serviceType = testNode.serviceType;
          currentFloorRoute.StartPoint = {x: testNode.x, y: testNode.y};
          currentFloorRoute.StartIcon = getMapIcon(serviceType);
          currentFloorRoute.RouteLine.push(polyline);

          fullRoute.push(currentFloorRoute);

          const targetFloor = testNode.BestLink.toNode.floorIndex;

          //start new route
          testNode = testNode.BestLink.fromNode;
          floorIndex = testNode.floorIndex;

          currentFloorRoute = new FloorRoute(floorIndex);
          currentFloorRoute.targetFloor = targetFloor;
          currentFloorRoute.targetFloorName = getFloorName(targetFloor);
          polyline = {Points: []};

          currentFloorRoute.GuidingIcon = getGuidingIcon(serviceType);
          currentFloorRoute.EndIcon = getMapIcon(serviceType);
          currentFloorRoute.EndPoint = {x: testNode.x, y: testNode.y};

          var points = {'x': testNode.x, 'y': testNode.y};
          polyline.Points.push(points);

          testNode = testNode.BestLink.fromNode;
          lastNodeOfRoute = testNode;
        }else{
          if(testNode.BestLink){
            polyline.Points.push({x: testNode.BestLink.fromNode.x, y: testNode.BestLink.fromNode.y});
            testNode = testNode.BestLink.fromNode;
          }
        }
        floorIndex = testNode.floorIndex;
      }

      currentFloorRoute.StartPoint = {x: testNode.x, y: testNode.y};
      currentFloorRoute.RouteLine.push(polyline);
      fullRoute.push(currentFloorRoute);
    }

    // Remember the route was constructed from last to first --> reverse
    fullRoute = fullRoute.reverse();

    // Now attach correct labels and icons
    var num = 0;

    for(var i=0; i< fullRoute.length; i++){
      if(fullRoute[i]){
        var route = fullRoute[i];
        //calculate the middle point and the length of the route
        var pointsCount = route.RouteLine[0].Points.length;
        var startPoint = route.RouteLine[0].Points[0];
        var endPoint = route.RouteLine[0].Points[pointsCount-1];

        var dx = endPoint.x - startPoint.x;
        var dy = endPoint.y - startPoint.y;
        var middlePoint = {x: startPoint.x + dx/2, y: startPoint.y + dy/2};

        const direction = getRouteDirection(route, dx, dy, minDirectionDistance, maxDirectionDistance);

        route.Distance = distance;
        route.MiddlePoint = middlePoint;

        // Add the initial 'walk to this direction routestep'
        if(i == 0) {
          num++;
          const initialDirection = new FloorRoute();

          initialDirection.FloorIndex = route.FloorIndex;
          initialDirection.StartPoint = route.StartPoint;
          initialDirection.EndPoint = route.StartPoint;
          initialDirection.StartIcon = 'pin_you-are-here';
          initialDirection.RouteLine = [{Points: []}];
          initialDirection.Num = num;
          initialDirection.direction = direction;
          initialDirection.MiddlePoint = {x: route.StartPoint.x, y: route.StartPoint.y};

          setStartingMessageAndIcon(initialDirection, direction);

          // Also add IMD location icon as the StartIcon for the route (route after 'go x direction')
          route.StartIcon = 'pin_you-are-here';
          // This is a bit dirty. Please note that for loop condition is evaluated on every loop --> fullRoute.length increases by one after this
          fullRoute.unshift(initialDirection);
          i++;
        }

        if (i == fullRoute.length - 1) {
          route.Msg = 'map.route.action.finishToDestination';
        } else {
          route = setRouteMessageAndIcon(route);
        }

        num++;
        route.Num = num;
      }
    }

    return fullRoute;
  }


  function getGuidingIcon(serviceType) {
    return Constants.SERVICE_TYPES.find(service => service.id == serviceType).icon;
  }

  function getMapIcon(serviceType) {
    return Constants.SERVICE_TYPES.find(service => service.id == serviceType).pinicon;
  }

  function getRouteDirection(route, dx, dy, minDirectionDistance, maxDirectionDistance) {
    var radians = calculateMeanInitialRouteDirection(route.RouteLine[0], minDirectionDistance, maxDirectionDistance);
    var distance = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
    var rotation = mapdata.imddata.rotation * Math.PI / 180;
    var direction = (radians + rotation) * 180/Math.PI; //to degrees

    direction = direction + 90; // set 0 degrees from right to top

    return direction;
  }

  function drawPaths(route){

    var routemarks = {dots: [], icons: []};
    var x;
    var y;
    var iconWidth = 30;
    var iconHeight = 30;
    var routeLine = route.RouteLine;

    for(var l in routeLine){
      var points = routeLine[l].Points;
      for(var p in points){
        x = points[p].x;
        y = points[p].y;
        routemarks.dots.push({x: x, y: y, width: 3, height: 3, type: 'circle'});
      }
    }

    if(route.StartIcon != ''){
      if(route.StartIcon=='pin_you-are-here'){
        routemarks.icons.push({x: route.StartPoint.x, y: route.StartPoint.y, width: iconWidth, height: iconWidth, path: context.resources.get(route.StartIcon), type: 'icon', id: 'you-are-here'});
      }else{
        routemarks.icons.push({x: route.StartPoint.x, y: route.StartPoint.y, width: iconWidth, height: iconWidth, path: context.resources.get(route.StartIcon), type: 'icon', id: ''});
      }
    }

    if(route.EndIcon != ''){
      routemarks.icons.push({x: route.EndPoint.x, y: route.EndPoint.y, width: iconWidth, height: iconHeight, path: context.resources.get(route.EndIcon), type: 'icon'});
    }

    if(route.Num == 1) {
      routemarks.icons.push(getInitialRouteDirectionIcon(route.StartPoint, route.direction));
    }

    return routemarks;
  }

  function drawStartNodes(floorIndex, startPoint = {}, services){
    var startNodes = [];
    var width = Constants.NODE_SELECT_ELLIPSE_RADIUS * 2;
    var height = Constants.NODE_SELECT_ELLIPSE_RADIUS * 2;
    const { mapPin = {} } = context.resources.themeConfig;
    const { useIcons } = mapPin;
    // var x = startPoint.x - width / 2;
    // var y = startPoint.y - height / 2;

    if(startPoint.floorIndex == floorIndex){
      startNodes.push({
        x: startPoint.x, y: startPoint.y,
        width, height,
        name: 'pin_you-are-here',
        path: context.resources.get('pin_you-are-here'),
        type: 'icon', class: 'active', id: 'you-are-here'
      });
    }
    $.each(services, function(i, service){
      if(service.floorIndex == floorIndex){
        startNodes.push({
          x: service.pinLocation.x, y: service.pinLocation.y,
          width, height,
          name: service.pinicon,
          path: context.resources.get(useIcons ? service.icon : service.pinicon),
          base: useIcons ? {
            path: context.resources.get('pin__base'),
            width: mapPin.width || width + 16,
            height: mapPin.height || height + 16
          } : false,
          type: 'icon',
          id: service.pinLocation.x+'x'+service.pinLocation.y,
          class: `service-${service.id}${useIcons ? ' icon--pin' : ''}`
        });
      }
    });
    return startNodes;
  }

  function getInitialRouteDirectionIcon(StartPoint, direction) {
    // direction - rotation of map (to zero it out) + angle of icon (135) + our 0 degrees is at 90 degrees
    const rotation = direction - mapdata.imddata.rotation + 135 + 90;
    const width = Constants.ICON_SIZE;
    const height = Constants.ICON_SIZE;

    return Object.assign({}, StartPoint, {
      width, height,
      path: '#ic_direction-135',
      type: 'icon',
      class: 'active fade-in',
      rotation,
      customTranslate: { x: -14, y: -14 } // offset of the dot center from top left corner
    });
  }

  /* GET FLOOR ID */
  function getFloorId(floorIndex){
    var floors = getFloors();
    for(var f in floors){
      if(floors[f].order==floorIndex){
        return floors[f].id;
      }
    }
  }
  function getFloorIndex(floorId){
    var floors = getFloors();
    for(var f in floors){
      if(floors[f].id==floorId){
        return floors[f].order;
      }
    }
  }
  function getFloorName(floorIndex){
    var floors = getFloors();
    for(var f in floors){
      if(floors[f].order==floorIndex){
        return floors[f].name;
      }
    }
  }

  function setStartingMessageAndIcon(route, direction) {
    route.Msg = 'direction.followTheArrow';

    direction = direction % 360;
    direction = direction < 0 ? (direction + 360) : direction;

    if(direction >= 0 && direction < 22.5){
      route.GuidingIcon = 'way_direction-000';
    }else if(direction >= 22.5 && direction < 67.5){
      route.GuidingIcon = 'way_direction-045';
    }
    else if(direction >= 67.5 && direction < 112.5){
      route.GuidingIcon = 'way_direction-090';
    }
    else if(direction >= 112.5 && direction < 157.5){
      route.GuidingIcon = 'way_direction-135';
    }
    else if(direction >= 157.5 && direction < 202.5){
      route.GuidingIcon = 'way_direction-180';
    }
    else if(direction >= 202.5 && direction < 247.5){
      route.GuidingIcon = 'way_direction-225';
    }
    else if(direction >= 247.5 && direction < 292.5){
      route.GuidingIcon = 'way_direction-270';
    }
    else if(direction >= 292.5 && direction < 337.5){
      route.GuidingIcon = 'way_direction-315';
    }
    else if(direction >= 337.5 && direction < 360){
      route.GuidingIcon = 'way_direction-000';
    }

    return route;
  }

  function setRouteMessageAndIcon(route) {
    if(route.GuidingIcon == 'ic_elevator'){
      if (route.FloorIndex < route.targetFloor) {
        route.Msg = 'map.route.action.takeTheElevatorUp';
      }else{
        route.Msg = 'map.route.action.takeTheElevatorDown';
      }
      route.TargetFloor = route.targetFloorName;
    }else if(route.GuidingIcon=='ic_escalator'){
      if (route.FloorIndex < route.targetFloor) {
        route.Msg = 'map.route.action.takeTheEscalatorUp';
      }else{
        route.Msg = 'map.route.action.takeTheEscalatorDown';
      }
      route.TargetFloor = route.targetFloorName;
    } else if(route.GuidingIcon=='ic_floor') {
      route.Msg = 'map.route.action.goToFloor';
      route.TargetFloor = route.targetFloorName;
    }
    return route;
  }

  const getRoundedDirection = (direction) => {
    direction = Math.abs(direction % 360);

    if (direction >= 0 && direction < 22.5){
      return 0;
    } else if(direction >= 22.5 && direction < 67.5){
      return 45;
    } else if(direction >= 67.5 && direction < 112.5){
      return 90;
    } else if(direction >= 112.5 && direction < 157.5){
      return 135;
    } else if(direction >= 157.5 && direction < 202.5){
      return 180;
    } else if(direction >= 202.5 && direction < 247.5){
      return 225;
    } else if(direction >= 247.5 && direction < 292.5){
      return 270;
    } else if(direction >= 292.5 && direction < 337.5){
      return 315;
    } else if(direction >= 337.5 && direction < 360){
      return 0;
    } else {
      0;
    }
  };

 export default {
    init,
    doFindShortestPathTree,
    doFindShortestPath,
    findClosestStoreLocationForStore,
    findClosestStoreLocationForStoreAtFloor,
    findClosestServiceLocation,
    drawStartNodes,
    drawPaths,
    getFloorName,
    getFloorIndex
  };
